import React from "react";
import AppAgent from "../Container/AppAgent";
import "./index.scss";

interface RootLayoutProps {
  children: React.ReactNode;
}

const RootLayout: React.FC<RootLayoutProps> = ({ children }) => {
  return (
    <div className="root-layout">
      <div style={{ flexShrink: 0 }}>
        <AppAgent />
      </div>
      <div className="root-layout-content">{children}</div>
    </div>
  );
};

export default RootLayout;
